import { z } from 'zod'

export const ARTIFACT_BUNDLE = z.object({
  version: z.literal(1), createdAt: z.string(), runId: z.string().optional(),
  files: z.array(z.object({ path: z.string().regex(/^(?:\.sightmap|\.sightkick|qa-tools)\/[a-zA-Z0-9_.-]+$/), contents: z.string() })),
  unsupported: z.array(z.object({ tool: z.string(), reasons: z.array(z.string()) })),
})
export type AppArtifactBundle = z.infer<typeof ARTIFACT_BUNDLE>
